import React, { useEffect, useState } from 'react';
import '../../css/Products/SideBarCategories.css';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { SpinningCircles } from 'react-loading-icons';

const SidebarCategories = ( {type, onCategoryClick }) => {
  console.log(type)
  const [categories, setCategories] = useState(null);
  const [openCategory, setOpenCategory] = useState(null);
  const navigate = useNavigate();
  const { category: activeCategory, subcategory: activeSubcategory } = useParams();

  useEffect(() => {
  const API = process.env.REACT_APP_BACKEND_URL;

  let apiRoute = '/wcategories'; // default
  if (type === 'machine') {
    apiRoute = '/category';
  } else if (type === 'material') {
    apiRoute = '/wcategories';
  }

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${API}${apiRoute}`);
      setCategories(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  fetchCategories();
}, [type]);

  const toggleCategory = (name) => {
    setOpenCategory(prev => (prev === name ? null : name));
  };

  if (!categories) {
    return <SpinningCircles />;
  }

  return (
    <aside className="sidebar-categories">
      <h3>Kategóriák</h3>

      {categories.map((cat, index) => (
        <div key={index} className="sidebar-category">
          <div
            className={`sidebar-category-title`}
            onClick={() => {
              toggleCategory(cat.category_name);
              onCategoryClick?.()
              navigate(`/termekek/${cat.category_name}?type=${type}`);
            }}
          >
            {cat.category_name}
          </div>

          {openCategory === cat.category_name && (
            <ul className="sidebar-subcategories">
              {cat.subcategories?.map((sub, subIndex) => (
                <li
                  key={subIndex}
                  
                  onClick={() => {
                    onCategoryClick?.();
                    navigate(`/termekek/${cat.category_name}/${sub.name}?type=${type}`);
                  }}
                >
                  {sub.name}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </aside>
  );
};

export default SidebarCategories;